<template>
  <!-- 订单回收站 -->
  <el-dialog
    width="1020px"
    :visible.sync="visible"
    title="回收站"
    :close-on-click-modal="false">
    <div class="y-f y-f-ae y-f-jb">
      <div class="y-f y-f-a y-f-wrap">
        <div class="y-f y-f-a">
          <el-select
          :popper-append-to-body="false"
          class="y-w-100"
          v-model="searchModel.timeType"
          placeholder="请选择">
            <el-option label="下单时间" :value="1"></el-option>
            <el-option label="删除时间" :value="0"></el-option>
          </el-select>
        </div>
        <div class="y-f y-f-a">
          <yto-date-picker
            :maxRangeVal="90"
            :customDaysName="`custom_recycle_customrange`"
            :curShortcutName="curShortcutName"
            :clearable="false"
            :editable="false"
            :picker-options="pickerOptions1"
            v-model="searchModel.createTime"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy.MM.dd HH:mm"
          ></yto-date-picker>
        </div>
        <div class="y-f y-f-a y-ml-10">
          <label class="y-mr-10">订单编号</label>
          <el-input class="y-f-1 y-w-160" v-model.trim="searchModel.orderCode" placeholder="请输入订单编号查询"></el-input>
        </div>
        <div class="y-f y-f-a y-ml-10">
          <label class="y-mr-10 y-ml-5">运单号</label>
          <el-input class="y-f-1 y-w-160" v-model.trim="searchModel.mailNo" placeholder="请输入运单号查询"></el-input>
        </div>
        <div class="y-f y-f-a y-mt-10">
          <label class="y-mr-5 y-ml-5">姓名</label>
          <el-input class="y-f-1 y-w-160" v-model.trim="searchModel.receiveSenderName" placeholder="请输入收寄件人姓名查询"></el-input>
        </div>
        <div class="y-f y-mt-10" style="margin-left:auto;">
          <el-button size="mini" type="primary" icon="el-icon-search" @click="getTableDataList">查询</el-button>
          <el-button size="mini" class="normal-btn" icon="el-icon-refresh-left" @click="reset">重置</el-button>
        </div>
      </div>
    </div>
    <div class="y-mt-20 y-mb-10">
      <i class="el-icon-warning y-fc-F0484A"></i>
      提示：回收站只保存订单创建时间在90天内的数据，超过90天不支持恢复。
    </div>
    <div>
      <el-table
        @select="tableSelect"
        @select-all="tableSelect"
        v-loading="loading"
        max-height="370px"
        :data="tableData"
        ref="multipleTable"
        style="width: 100%">
        <el-table-column type="selection" width="45"></el-table-column>
        <el-table-column label="删除时间" prop="updateTime"></el-table-column>
        <el-table-column label="下单时间" prop="createTime"></el-table-column>
        <el-table-column label="订单状态" width="70">
          <template slot-scope="scope">
            {{ scope.row.printStatus == 0 ? '未打印': '已打印' }}
          </template>
        </el-table-column>
        <el-table-column label="订单编号" prop="orderCode"></el-table-column>
        <el-table-column label="寄件人" width="70" prop="senderName"></el-table-column>
        <el-table-column label="收件人信息">
          <template slot-scope="scope">
            {{ scope.row.receiveName }}&nbsp;{{ scope.row.receiveMobile }}&nbsp;{{ scope.row.receivePhone }}
            <br />
            {{ scope.row.receiveProvince }}{{ scope.row.receiveArea }}{{ scope.row.receiveCity }}{{ scope.row.receiveAddress }}
          </template>
        </el-table-column>
        <el-table-column prop="mailNo">
          <template slot="header">
            <span class="y-ml-10">运单号</span>
          </template>
          <template slot-scope="scope">
            {{ scope.row.mailNo || '-' }}
          </template>
        </el-table-column>
        <el-table-column width="85">
          <template slot="header">
            <span class="y-ml-10">操作</span>
          </template>
          <template slot-scope="scope">
            <el-button type="text" size="mini" class="y-fc-4C84FF" @click="handleResume(scope.row)">恢复</el-button>
            <el-popconfirm
              title="删除后无法恢复，请确认是否删除？"
              icon="el-icon-warning"
              @confirm="handleDelete(scope.row)"
              icon-color="red">
              <span slot="reference" class="y-fc-F35252 y-c-p y-ml-5">删除</span>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="y-t-ac y-mt-20 y-mb-20"
        @size-change="limitChange"
        @current-change="pageChange"
        :current-page.sync="searchModel.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="searchModel.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
    <div class="y-t-ac">
      <el-button class="y-w-120" size="mini" type="default" @click="handleClose">关闭</el-button>
      <el-button class="y-w-120" size="mini" type="primary" @click="handleMulResume">批量恢复</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { orderRecycleApi, queryOrderRecycleApi, recycleDeleteApi } from '../../../../api/waybillPrint/customPrint';
import { copyText, dateFormat,  YTOSHORTCUTS} from '../../../../utils/util';
export default {
  props: ['showRecycleDialog'],
  data() {
    let self = this
    return {
      visible: false,
      tableData: [],
      searchModel: {
        timeType: 0, // 时间类型
        createTime: '', // 时间段
        orderCode: '', // 订单编号
        mailNo: '', // 运单号
        receiveSenderName: '', // 姓名
        pageNum: 1, // 页码
        pageSize: 10, // 每页显示条数
      },
      total: 0, // 数据总条数
      loading: false, // 表格的loading
      selectedData: [], // 选中的数据
      curShortcutName: '',
      pickerOptions1: {
       
        ...YTOSHORTCUTS,
        onPick: ({ maxDate, minDate }) => {
          // 把选择的第一个日期赋值给一个变量。
          self.choiceDate = minDate.getTime();
          // 如何你选择了两个日期了，就把那个变量置空
          if (maxDate) self.choiceDate = "";
        },

        disabledDate(time) {
          // 只能选择90天内的数据
          if (self.choiceDate ) {
            // 31天的时间戳
            const one = 30 * 24 * 3600 * 1000;
            // 当前日期 - one = 31天之前
            const minTime = self.choiceDate - one;
            // 当前日期 + one = 31天之后
            const maxTime = self.choiceDate + one;
            return (
              time.getTime() < minTime ||
              time.getTime() > maxTime
            ||time.getTime() > new Date(`${dateFormat(new Date(), 'yyyy-MM-dd')} 23:59:59`).getTime() ||
            time.getTime() < new Date().setDate(new Date().getDate() - 90)
            );
          } else {
            return (
            time.getTime() > new Date(`${dateFormat(new Date(), 'yyyy-MM-dd')} 23:59:59`).getTime() ||
            time.getTime() < new Date().setDate(new Date().getDate() - 90)
          )
          }

        }
      },
    }
  },
  methods: {
    // 初始化时间
    initTime() {
      let createTime = [];
      let agoDays = '';
      if(localStorage.getItem(`custom_recycle_customrange`)) {
        let customrange = JSON.parse(localStorage.getItem(`custom_recycle_customrange`));
        agoDays = new Date(new Date().getTime() - (customrange.dateRange>30?30:customrange.dateRange) * 24 * 3600 * 1000);
        this.curShortcutName = customrange.curShortcutName;
        if(this.curShortcutName === 'customRange') {
          // 只有是记住天数选项才使用记住的那个天数时间
          createTime = [
            `${dateFormat(agoDays, 'yyyy-MM-dd')} 00:00:00`,
            `${dateFormat(new Date(), 'yyyy-MM-dd')} 23:59:59`
          ]
        } else {
          let shortcutsMap = getShortcutsMap()
          createTime = shortcutsMap[this.curShortcutName];
        }
        this.$set(this.searchModel, 'createTime', createTime);
      } else {
        agoDays = new Date(new Date().getTime() - 30 * 24 * 3600 * 1000);
        // 初始化下单日期
        createTime = [
          `${dateFormat(agoDays, 'yyyy-MM-dd')} 00:00:00`,
          `${dateFormat(new Date(), 'yyyy-MM-dd')} 23:59:59`
        ];
        this.$set(this.searchModel, 'createTime', createTime);
      }
    },
    reset() {
      this.searchModel.timeType = 0;
      this.searchModel.orderCode = '';
      this.searchModel.mailNo = '';
      this.searchModel.receiveSenderName = '';
      this.searchModel.pageNum = 1;
      this.initTime();
      this.getTableDataList();
    },
    tableSelect(selection) {
      this.selectedData = selection;
    },
    handleDelete(val) {
      // 删除
      let params = {
        orderCodeList: [val.orderCode]
      }
      this.loading = true;
      recycleDeleteApi(params).then(res => {
        if(res.message == '成功') {
          this.searchModel.pageNum = 1;
          this.getTableDataList();
        } else {
          this.$message.error('删除失败')
        }
      }).catch(() => {
        this.$message.error('服务器错误')
      }).finally(() => {
        this.loading = false;
      })
    },
    handleResume(val) {
      let params = {
        orderCodeList: [val.orderCode]
      }
      this.handleRecycle(params, 'single');
    },
    handleMulResume() {
      // 批量恢复
      if(this.selectedData.length <= 0) {
        this.$message.error('请选择需要恢复的数据');
        return;
      }
      let params = {
        orderCodeList: []
      }
      this.selectedData.forEach(item => {
        params.orderCodeList.push(item.orderCode)
      })
      this.handleRecycle(params, 'multiple');
    },
    handleRecycle(params, type) {
      // 处理恢复逻辑
      this.loading = true;
      orderRecycleApi(params).then(res => {
        if(res.message === '成功') {
          if(type === 'single') {
            // 单条恢复 需要复制订单号
            copyText(params.orderCodeList[0], '恢复成功，订单编号已复制到你的剪切板');
          }
          if(type === 'multiple') {
            // 批量恢复 啥也不是
            this.$message.success('恢复成功，请去待打印或已打印页面查看');
          }
          this.$emit('closeFunc')
          this.visible = false;
        } else {
          this.$message.error('恢复数据失败');
        }
      }).catch(() => {
        this.$message.error('服务器错误');
      }).finally(() => {
        this.loading = false;
        this.selectedData = [];
      })
    },
    limitChange(val) {
      this.searchModel.pageSize = val;
      this.searchModel.pageNum = 1;
      this.getTableDataList();
    },
    pageChange(val) {
      this.searchModel.pageNum = val;
      this.getTableDataList();
    },
    handleClose() {
      this.visible = false;
    },
    getTableDataList() {
      this.loading = true;
      let params = {
        ...this.searchModel,
        startCreateDate: this.searchModel.createTime[0], 
        endCreateDate: this.searchModel.createTime[1],
      };
      if (params.createTime && params.createTime.length) {
        delete params.createTime;
      }
      queryOrderRecycleApi(params).then(res => {
        if(res.message === '成功') {
          this.tableData = res.data.resultData;
          this.total = res.data.total;
        } else {
          this.total = 0;
          this.tableData = [];
          this.$message.error('获取数据失败');
        }
      }).catch(() => {
        this.total = 0;
        this.tableData = [];
        this.$message.error('服务器错误');
      }).finally(() => {
        this.loading = false;
      })
    },
  },
  watch: {
    showRecycleDialog(val) {
      this.visible = val;
    },
    visible(val) {
      this.$emit('update:showRecycleDialog', val);
      if(val) {
        this.initTime();
        this.tableData = [];
        this.getTableDataList();
      }
    }
  }
}
</script>